
var id = "numberUp";
var markup = "<symbol viewBox=\"0 0 8 12\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"numberUp\">\n    <title>Path</title>\n    <g id=\"numberUp_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"numberUp_品牌健康中心-新-copy\" transform=\"translate(-966.000000, -326.000000)\" fill=\"#4CAF50\" fill-rule=\"nonzero\">\n            <g id=\"numberUp_Total-Sales---ALL\" transform=\"translate(304.000000, 258.000000)\">\n                <g id=\"numberUp_Total-Sales\" transform=\"translate(40.000000, 40.000000)\">\n                    <g id=\"numberUp_Total-Sales---data\" transform=\"translate(0.000000, -0.000000)\">\n                        <g id=\"numberUp_Group-23\" transform=\"translate(522.000000, 25.000000)\">\n                            <g id=\"numberUp_shangshengjiantouicon2-copy-3\" transform=\"translate(100.000000, 3.000000)\">\n                                <path d=\"M0.351515152,5.17272727 L4.17575758,0 L8,5.17272727 L6.30454545,5.17272727 C6.28787879,5.32424242 6.26818182,5.48030303 6.24090909,5.64393939 C5.65454545,9.40757576 3.57424242,11.5257576 0,12 C1.58181818,9.74242424 2.4,7.54242424 2.45454545,5.40151515 L2.45757576,5.17272727 L0.351515152,5.17272727 Z\" id=\"numberUp_Path\" />\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
